import { render, staticRenderFns } from "./cpt-rect-num.vue?vue&type=template&id=02852a06&scoped=true&"
import script from "./cpt-rect-num.vue?vue&type=script&lang=js&"
export * from "./cpt-rect-num.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02852a06",
  null
  
)

export default component.exports